module.exports = __webpack_public_path__ + "static/k2-9378c43cbf7447b48e11730c3ec5b63d.jpg";